// After a deploy the hashed chunk files of the previous build disappear, so a
// stale tab's next lazy navigation fails and a click appears to do nothing.
// Vite surfaces that as `vite:preloadError`: reload once to pick up the new
// build, with a cooldown so a genuinely broken chunk cannot reload-loop.
// Registered from the entry point BEFORE the app mounts, so the very first
// lazy route of a stale tab is covered too.
const PRELOAD_RELOAD_FLAG = 'arca-chunk-reload-at'
const PRELOAD_RELOAD_COOLDOWN_MS = 30_000

function readLastReload(): number {
  try {
    return Number(sessionStorage.getItem(PRELOAD_RELOAD_FLAG) ?? 0)
  } catch {
    // Storage can throw (privacy modes): treat as "no reload recorded".
    return 0
  }
}

function markReload(): boolean {
  try {
    sessionStorage.setItem(PRELOAD_RELOAD_FLAG, String(Date.now()))
    return true
  } catch {
    // Without storage there is no loop guard — skip the automatic reload.
    return false
  }
}

export function installChunkReloadRecovery(): void {
  if (typeof window === 'undefined') return
  window.addEventListener('vite:preloadError', (event) => {
    if (Date.now() - readLastReload() < PRELOAD_RELOAD_COOLDOWN_MS) return
    if (!markReload()) return
    event.preventDefault()
    window.location.reload()
  })
}
